var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormatSheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 80,
    viewBox: "0 0 56 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 56,
    height: 40,
    fill: "#A8A7CC",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 36,
    height: 2,
    fill: "#52509A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 36,
    height: 2,
    fill: "#52509A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 24,
    height: 2,
    fill: "#52509A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 24,
    height: 2,
    fill: "#52509A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 56H24V64H32V56Z",
    stroke: "#52509A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 64L30 60L32 62",
    stroke: "#52509A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 56L29 61",
    stroke: "#52509A",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 8.20711V79.5H0.5V0.5H47.7929L55.5 8.20711Z",
    stroke: "#A8A7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 0V8.5H56",
    stroke: "#A8A7CC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatSheet);
export default __webpack_public_path__ + "static/media/format-sheet.78362dbc8300791566862ee67e093108.svg";
export { ForwardRef as ReactComponent };